import { useState } from "react";
import { Helmet } from "react-helmet";
import AgeResult from "../components/AgeResult";
import BackButton from "../components/BackButton";

export default function AgeCalculator() {
  const [dob, setDob] = useState("");
  const [age, setAge] = useState(null);

  const calculateAge = () => {
    const birthDate = new Date(dob);
    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    setAge({ years, months, days });
  };

  return (
    <>
      <Helmet>
        <title>Age Calculator Online - Calculate Exact Age in Years, Months & Days</title>
        <meta name="description" content="Free Age Calculator Online - Find your exact age in years, months, and days. No signup needed. Easy & accurate DOB to age tool." />
        <meta name="keywords" content="age calculator, date of birth to age, online age calculator, DOB calculator, calculate age online" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/age-calculator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Age Calculator Tool</h2>
          <p>Enter your date of birth to calculate your exact age.</p>
          <input
            type="date"
            className="form-control w-50"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
          />
          <button className="btn btn-primary mt-3" onClick={calculateAge}>
            Calculate Age
          </button>

          <AgeResult result={age} />
        </div>
      </section>
    </>
  );
}
